export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/occurrence/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        setTrainings: {
            method: 'POST',
            url: `${url}/set-trainings`,
            isArray: true
        },
        getTrainings: {
            method: 'GET',
            isArray: true,
            url: `${url}/get-trainings`
        },
        addParticipants: {
            method: 'POST',
            url: `${url}/add-participants`,
            isArray: true
        },
        removeParticipants: {
            method: 'POST',
            url: `${url}/remove-participants`,
            isArray: true
        },
        getEvents: {
            method: 'GET',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/get-events`,
            isArray: true
        },
        getTrainingTimeParticipants: {
            method: 'GET',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence-training-time`,
            isArray: true
        },
        // TODO move to separate resource
        setTrainingTimeParticipants: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence-training-time/:id/set-participants`,
            isArray: true
        },
        getParticipants: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/participants`,
            isArray: true
        },
        getOccurrences: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/occurrencies`,
            isArray: true
        },
        getUsers: {
            method: 'GET',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/users`,
            isArray: true
        },
        getEnrolledUsers: {
            method: 'GET',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/enrolled-users`,
            isArray: true
        },
        setPassedCourses: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/set-passed-courses`,
            isArray: true
        },
        assessTestTraining: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/assess-test-training`
        },
        handleOverdueDeadline: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}course/occurrence/training-overdue-deadline`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Occurrence/index.js